import {
    CANCEL_BOOKING_DETAIL_START,
    CANCEL_BOOKING_DETAIL_SUCCESS,
    CANCEL_BOOKING_DETAIL_ERROR,
    CANCEL_BOOKING_SAVE_SUCCESS,
    CANCEL_BOOKING_SAVE_ERROR
  } from "Constant";
  
  const initialState = {
    loading: false,
    data: {},
      // data:null
      
  };
  
  export default function CancelRiderReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case CANCEL_BOOKING_DETAIL_START:
        return {
          ...state,
          loading: true,
        };
      case CANCEL_BOOKING_DETAIL_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case CANCEL_BOOKING_DETAIL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
        case CANCEL_BOOKING_SAVE_SUCCESS:
        return {
          ...state,
          loading: false,
          message: action.payload,
        };
        case CANCEL_BOOKING_SAVE_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  